export default __webpack_public_path__ + "static/media/appertment.0b10a184.jpg";